import { OrdersGridColumns } from './orders-grid-columns';
import { SERVICE_COLLECTION } from '../../../filters/constants';

export const defaultOrderBy = 'OrderDateTimeDesc';
export const defaultOrderByAsObject = {
  orderBy: 'OrderDateTime',
  orderByDirection: 'Descending',
};

export const baseColumnsDefaultConfigs = [
  { id: 'order-number', width: 150 },
  { id: 'age', width: 70 },
  { id: 'orderDate', width: 107, sorted: 'descending' },
  {
    id: 'notes',
    width: 105,
    minWidth: 105,
    nonsortable: true,
  },
  { id: 'gift', width: 70 },
  { id: 'item-sku', width: 150 },
  { id: 'item-name', width: 150 },
  { id: 'open-batch-name', width: 150, nonsortable: true },
  { id: 'company-name', width: 150 },
  { id: 'recipient', width: 150 },
  { id: 'quantity', width: 93 },
  { id: 'order-total', width: 110 },
  { id: 'allocation-status', width: 150, nonsortable: true },
].map((column, index) => ({
  ...column,
  minWidth: 70,
  index,
  pinned: false,
  shown: true,
}));

// TODO - Allocated, OrderWeight/ShippingWeight, Warehouse
const otherColumnsDefaultConfigs = [
  { id: 'amount-paid', width: 121 },
  { id: 'assignedTo', width: 150 },
  { id: 'buyer', width: 150 },
  { id: 'buyer-id', width: 150 },
  { id: 'carrier', width: 150 },
  { id: 'client-name', width: 150 },
  { id: 'company', width: 100 },
  { id: 'confirmation', width: 122 },
  { id: 'country', width: 90 },
  { id: 'custom1', width: 134 },
  { id: 'custom2', width: 134 },
  { id: 'custom3', width: 134 },
  { id: 'holdUntil', width: 102 },
  { id: 'package', width: 110 },
  { id: 'packing-slip-printed', width: 168 },
  { id: 'pick-list-printed', width: 168 },
  { id: 'paidDate', width: 100 },
  { id: OrdersGridColumns.PickingException, width: 180 },
  { id: 'pickup-status', width: 100 },
  { id: 'pickup-time', width: 100 },
  { id: OrdersGridColumns.PremiumPrograms, width: 150, nonsortable: true },
  { id: 'rate', width: 100 },
  { id: 'requested-service', width: 158 },
  { id: 'service', width: 150 },
  { id: SERVICE_COLLECTION, width: 150 },
  { id: 'deliver-by', width: 152 },
  { id: 'ship-by', width: 100 },
  { id: 'shipDate', width: 100 },
  { id: 'shipFrom', width: 120 },
  { id: 'shippingAccount', width: 151 },
  { id: 'shippingPaid', width: 150 },
  { id: 'source', width: 86 },
  { id: 'state', width: 73 },
  { id: 'status', width: 150 },
  { id: 'store', width: 150 },
  { id: 'tags', width: 100 },
  { id: 'taxPaid', width: 94 },
  { id: 'warehouse-status', width: 155 },
  { id: 'weight', width: 124 },
  { id: 'zone', width: 71 },
  { id: 'warehouse-location', width: 180 },
  { id: 'fulfillment-status', width: 180, minWidth: 120 },
].map((column) => ({
  ...column,
  minWidth: 70,
}));

export const allSearchResultColumnsConfigs = [
  { id: 'order-number', width: 150 },
  { id: 'status', width: 150, nonsortable: true },
  { id: 'age', width: 70 },
  { id: 'item-name', width: 150 },
  { id: 'item-sku', width: 150 },
  { id: 'notes', width: 105, nonsortable: true },
  { id: 'open-batch-name', width: 150, nonsortable: true },
  { id: 'company-name', width: 150 },
  { id: 'orderDate', width: 107, sorted: 'descending' },
  { id: 'gift', width: 70 },
  { id: 'recipient', width: 150 },
  { id: 'quantity', width: 93 },
  { id: 'order-total', width: 110 },
].map((column, index) => ({
  ...column,
  minWidth: 70,
  index,
  pinned: false,
  shown: true,
}));

const combinedColumnConfigurations = [...baseColumnsDefaultConfigs, ...otherColumnsDefaultConfigs].map((column, index) => ({
  ...column,
  index,
}));

export const defaultColumnConfigurations = combinedColumnConfigurations;
